import type { ReactNode } from 'react'

export function chipClass(active: boolean): string {
  return `whitespace-nowrap rounded-full border px-3.5 py-1.5 text-[13px] transition-colors ${active ? 'border-ink bg-ink text-ivory' : 'border-rule-strong bg-paper text-ink-2 hover:bg-bone'}`
}

export function AnalyticsSection({ id, index, eyebrow, title, aside, children }: {
  id: string
  index: string
  eyebrow: string
  title: string
  aside?: ReactNode
  children: ReactNode
}) {
  const titleId = `${id}-title`
  return (
    <section id={id} aria-labelledby={titleId} className="analytics-anchor mb-9 flex flex-col gap-3.5 sm:mb-11">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6">
        <div className="flex flex-col gap-1">
          <div className="eyebrow">{index} · {eyebrow}</div>
          <h2 id={titleId} className="text-[21px] font-semibold tracking-tight text-ink sm:text-[24px]">{title}</h2>
        </div>
        {aside && <div className="flex flex-wrap items-center gap-2.5 text-[13px] text-ink-muted">{aside}</div>}
      </div>
      {children}
    </section>
  )
}
